<div class="maOverlay" *ngIf="isVisible"></div>
<div class="maHistoryDetailsPopup d-flex flex-column  modal-container" *ngIf="isVisible">
    <div *ngIf="true">
        <div class="maDetailsPopupClose close-modal show-on-load close-container" (click)="hide()"></div>
    </div>
    <div class="position-relative h-100 modal-container">
        <div class="FlexRowNoWrap modal-header">
            <div class="maHistoryDetailsTitle" cvLocalizedText langSection="Challenges" langKey="History" >History</div>
            <div class="header-history">
                <cv-awards-export-button [startDate]="startDate ? startDate.toISOString() : ''"
                    [endDate]="endDate ? endDate.toISOString() : ''" [filterText]="filterText">
                </cv-awards-export-button>
                <cv-baremetrics-calendar *ngIf="presets != null" class="d-block daterange daterange--double"
                    [startDate]="startDate" [endDate]="endDate" [presets]="presets"
                    (dateChanged)="handleDateChanged($event)" [latestDate]="latestDate"></cv-baremetrics-calendar>
                <div class="sgInputFilterContainer input-filter">
                    <input type="search" class="sgInputFilter input" autocomplete="off" placeholder="Search"
                        cvLocalizedPlaceholder langSection="Common" langKey="Search" id="filterText" [(ngModel)]="filterText"
                        (ngModelChange)="filterAwardHistory()" />
                    <div class="input-icon" [ngClass]="{'sgClearFilterIcon': filterText.length > 0, 'sgInputFilterIcon': filterText.length === 0}"
                        (click)="clearSearch();"></div>
                </div>
            </div>
        </div>
        <div class="position-relative h-100">
            <div class="ag-grid-wrapper">
                <ag-grid-angular 
                    #awardsHistoryListGrid
                    id="ordersGrid" 
                    class="ag-theme-balham font-size-14 ag-grid-table" 
                    [gridOptions]="gridOptions"
                    (filterChanged)="updateGridFilter()" 
                    enableFilter="true">
                </ag-grid-angular>
            </div>
            <div class="cv-loader-container">
            <cv-loader 
                size="medium" 
                [overlay]="true" 
                *ngIf="loading">
            </cv-loader>
            </div>
        </div>
    </div>
</div>